module.exports = __webpack_public_path__ + "static/media/tg.aff94a79.svg";